import React from 'react';
import { Link } from 'react-router-dom';
import SignUpBtn from '../../../image/home/Swasth-provider-signup-btn.png';
import HIPAA from '../../../image/home/Swasth-provider-HIPAA-logo.png';

export default function SignupSection() {
  return (
    <div className='signup-section'>
      <div className='-content centered-content'>
        <p className='base-text'>
          97% of our clinicians
          <br />
          would recommend <span className='imp_text target-text'>Resiliens for clinicians</span> to another
          provider.
        </p>
        <div className='action-section'>
          <Link to='/signup'>
            Signup Now
          </Link>
          <img className='brand_log' src={HIPAA} />
        </div>
      </div>
    </div>
  );
}
